export const REFUND = 'REFUND';
export const DECLINED = 'DECLINED';
export const CREDIT = 'CREDIT';
